// extracted by mini-css-extract-plugin
export default {"mobile":"mobile__bLGktwBYNVJGmbVGDiwh","mobileStoreButtons":"mobileStoreButtons__wI2PBhtOCUW6z4rRxgJ2","mockUp":"mockUp__xTOKibPiDDRp7NPt08Xr"};